import { render, staticRenderFns } from "./PackagingServices.vue?vue&type=template&id=5b8cec5b&scoped=true&"
import script from "./PackagingServices.vue?vue&type=script&lang=js&"
export * from "./PackagingServices.vue?vue&type=script&lang=js&"
import style0 from "./PackagingServices.vue?vue&type=style&index=0&id=5b8cec5b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8cec5b",
  null
  
)

export default component.exports